class ImageGallery {
  constructor() {
    this.initImageGallery();
  }

  initImageGallery = () => {
    let gallerySwiper = new Swiper(".swiper-gallery", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      },
    });
  }
}

if (document.querySelector('.swiper-gallery')) {
  new ImageGallery();
}
